export class API {
    //User
    public static userLoginGoogle: string = 'user/login/google'
    public static userLoginApple: string = 'user/login/apple'

    //Course Manager
    public static courseManagerCreate: string = 'course-manager/create'
    public static courseManagerLogin: string = 'course-manager/login'
    public static courseManagerLogout: string = 'course-manager/logout'
    public static courseManagerDelete: string = 'course-manager/delete'
    public static courseManagerDetails: string = 'course-manager/details'
    public static courseManagerResetPassword: string = 'course-manager/reset_password'
    public static courseManagerChangePassword: string = 'course-manager/change_password'
    public static courseManagerAlterPassword: string = 'course-manager/alter_password_after_reset'
    public static courseManagerAlterEmail: string = 'course-manager/alter_email'

    //Course
    public static courseList: string = 'course/list'
    public static courseDetails = (courseId: string) => `course/${courseId}/details`
    public static courseAlter = (courseId: string) => `course/${courseId}/alter`

    //Lesson Picture
    public static lessonPictureList: string = 'lesson-picture/list'
    public static lessonPictureDetails = (lessonPictureId: string) => `lesson-picture/${lessonPictureId}/details`
    public static lessonPictureDownload = (lessonPictureId: string) => `lesson-picture/${lessonPictureId}/download`

    //Lesson
    public static lessonCreate: string = 'lesson/create'
    public static lessonAlter = (lessonId: string) => `lesson/${lessonId}/alter`
    public static lessonTogglePublication = (lessonId: string) => `lesson/${lessonId}/toggle-publication`
    public static lessonDelete = (lessonId: string) => `lesson/${lessonId}/delete`
    public static lessonList = (courseId: string) => `lesson/${courseId}/list`
    public static lessonListPublished = (courseId: string) => `lesson/${courseId}/list-published`
    public static lessonDetails = (lessonId: string) => `lesson/${lessonId}/details`

    //Lesson Page
    public static lessonPageCreate: string = 'lesson-page/create'
    public static lessonPageAlter = (lessonPageId: string) => `lesson-page/${lessonPageId}/alter`
    public static lessonPageDelete = (lessonPageId: string) => `lesson-page/${lessonPageId}/delete`
    public static lessonPageList = (lessonId: string) => `lesson-page/${lessonId}/list`
    public static lessonPageDetails = (lessonPageId: string) => `lesson-page/${lessonPageId}/details`

    //Lesson Page Item
    public static lessonPageItemCreate: string = 'lesson-page-item/create'
    public static lessonPageItemUpload: string = 'lesson-page-item/upload'
    public static lessonPageItemAlter = (lessonPageItemId: string) => `lesson-page-item/${lessonPageItemId}/alter`
    public static lessonPageItemDelete = (lessonPageItemId: string) => `lesson-page-item/${lessonPageItemId}/delete`
    public static lessonPageItemList = (lessonPageId: string) => `lesson-page-item/${lessonPageId}/list`
    public static lessonPageItemDetails = (lessonPageItemId: string) => `lesson-page-item/${lessonPageItemId}/details`
    public static lessonPageItemDownload = (lessonPageItemId: string) => `lesson-page-item/${lessonPageItemId}/download`

    //Lesson Page Item Type
    public static lessonPageItemTypeList: string = 'lesson-page-item-type/list'
    public static lessonPageItemTypeDetails = (lessonPageItemTypeId: string) => `lesson-page-item-type/${lessonPageItemTypeId}/details`

    //Quiz Answer
    public static quizAnswerCreate: string = 'quiz-answer/create'
    public static quizAnswerAlter = (quizAnswerId: string) => `quiz-answer/${quizAnswerId}/alter`
    public static quizAnswerDelete = (quizAnswerId: string) => `quiz-answer/${quizAnswerId}/delete`
    public static quizAnswerList = (lessonPageItemId: string) => `quiz-answer/${lessonPageItemId}/list`
    public static quizAnswerDetails = (quizAnswerId: string) => `quiz-answer/${quizAnswerId}/details`

    //Lesson Page Item Progress
    public static lessonPageItemProgressCreate: string = 'lesson-page-item-progress/create'
    public static lessonPageItemProgressList: string = 'lesson-page-item-progress/list'
    public static lessonPageItemProgressForItem = (lessonPageItemId: string) => `lesson-page-item-progress/for-item/${lessonPageItemId}`

    //Unlocked Lesson
    public static unlockedLessonCreate: string = 'unlocked-lesson/create'
    public static unlockedLessonList: string = 'unlocked-lesson/list'
    public static unlockedLessonForLesson = (lessonId: string) => `unlocked-lesson/for-lesson/${lessonId}`
}
